import React from "react";
import LayoutHOC from "../LayoutHOC";
import useCandidateAppliedJobs from "../../hooks/useCandidateAppliedJobs";

const EmploymentJobApplied = ({ id }) => {
  const appliedJobs = useCandidateAppliedJobs(id); // Example: [{id, employee_id, jobPosition, company_name, status}]

  if (!appliedJobs || appliedJobs.length === 0) {
    return (
      <div className="p-4">
        <p className="text-gray-600">No jobs applied yet.</p>
      </div>
    );
  }

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">Applied Jobs</h2>

      <ul className="divide-y divide-gray-200 border rounded-md">
        {appliedJobs.map((job) => (
          <li
            key={job.id}
            className="p-4 flex flex-col gap-2 md:flex-row md:justify-between md:items-center"
          >
            {/* Left: Position & Company */}
            <div>
              <p className="text-gray-600  text-sm">
                <span className="font-semibold">Position:</span>{" "}
                {job.jobPosition}
              </p>
              <p className="text-gray-600 text-sm">
                {" "}
                <span className="font-semibold">Company Name:</span>{" "}
                {job.company_name}
              </p>
            </div>

            {/* Right: Job Details */}
            <div className="mt-2 md:mt-0 text-sm">
              <p className="text-gray-600">
                <span className="font-semibold">Status:</span> {job.status}
              </p>
              <p className="text-gray-700">
                <span className="font-semibold">Job ID:</span> {job.id}
              </p>
              <p className="text-gray-700">
                <span className="font-semibold">Job Status Date:</span>{" "}
                {new Date(job.updated_at).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LayoutHOC(EmploymentJobApplied);
